"use client";

import { motion, useReducedMotion } from "framer-motion";
import { ShieldCheck, HeartHandshake, Compass } from "lucide-react";
export default function Trust() {
  const shouldReduceMotion = useReducedMotion();
  const values = [{
    icon: ShieldCheck,
    title: "Pratique & Concret",
    description: "Un manuel écrit par une famille pour les familles, loin de la théorie."
  }, {
    icon: Compass,
    title: "Sans fioritures",
    description: "La réalité des démarches, les pièges à éviter et la vraie vie locale."
  }, {
    icon: HeartHandshake,
    title: "Données à jour",
    description: "Des fiches et des outils calés sur les réglementations 2026."
  }];
  return <section id="authortrust" data-nav="light" className="relative overflow-hidden bg-background py-20 text-foreground md:py-28">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="flex flex-col items-center text-center">
          {/* Author Portrait */}
          <div className="relative mb-8">
            <div className="size-28 sm:size-32 md:size-36 overflow-hidden rounded-full border-4 border-muted shadow-md ring-2 ring-accent/30">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682238/img/author_lydia_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682238/img/author_lydia_portrait.png-wvc-sizes" alt="Lydia, auteure du blog Une Vie en Suède" loading="lazy" decoding="async" className="size-full object-cover object-center" src="https://unevieensuede.com/wp-content/uploads/2026/08/Lydia_Insta.png" />
            </div>
            <div className="absolute -bottom-2 right-1/2 translate-x-1/2 rounded-full bg-secondary px-3 py-0.5 text-xs font-medium text-secondary-foreground shadow-xs">
              Auteure
            </div>
          </div>

          {/* Section Heading */}
          <h2 className="mb-6 font-serif text-3xl tracking-tight text-foreground !font-normal sm:text-4xl">
            Pourquoi faire confiance à ce contenu
          </h2>

          {/* Core Trust Statement Card */}
          <div className="mb-12 max-w-3xl rounded-2xl border border-border bg-muted/40 p-6 sm:p-8 md:p-10 shadow-xs">
            <p className="font-serif text-lg leading-relaxed text-foreground sm:text-xl md:text-2xl">“Je suis Lydia, l'auteure du blog et du compte Instagram Une Vie en Suède, où je documente notre installation depuis 2025. Je n'ai pas de promesse de vie parfaite à vous vendre, ce blog refuse justement de vendre du rêve. Ce guide, c'est la version organisée et complète de tout ce qu'on a vécu et appris, avec la même honnêteté que dans mes chroniques.”</p>
          </div>

          {/* Key Value Points */}
          <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-3">
            {values.map((item, i) => {
            const IconComponent = item.icon;
            return <div key={item.title} data-index={i} className="flex flex-col items-center rounded-xl border border-border bg-card p-5 text-center shadow-xs">
                  <div className="mb-3 flex size-10 items-center justify-center rounded-full bg-secondary/15 text-accent">
                    <IconComponent className="size-5" />
                  </div>
                  <h3 className="mb-1 font-serif text-base font-semibold text-card-foreground">
                    {item.title}
                  </h3>
                  <p className="text-xs leading-relaxed text-muted-foreground">
                    {item.description}
                  </p>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}